import React from 'react';
import './ActivityPage.css';

import { Activity, Heading, PageTitle } from '../../../components';
import { activities } from '../../../constants';



const ActivityPage = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Activities'} page={'Activities'} />

      <section className='activities'>

        {/* Section heading */}
        <Heading title={'Our activities'} subTitle={'Explore Our Premier activities'} />

        <div className='box-container'>

          {/* Map over the activities array to render each activity */}
          {activities.map((activity) => { 
            return (
              <Activity key={activity.id} activity={activity} />
            );
          })}

        </div>

      </section>

    </>

  )
}

export default ActivityPage;